function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#F5F5F5"
}, React.createElement("path", {
  d: "M267.028 1608.485l-26.52 69.085c-37.26-14.303-55.87-56.104-41.568-93.364l.622-1.62 67.466 25.899z",
  transform: "translate(-194 -1582)"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 73,
    height: 96,
    viewBox: "0 0 73 96"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/figure-2.1c1d5c13.svg";
export { SvgComponent as ReactComponent };